import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

const GRID_COLUMNS = [
  {
    field: 'date',
    columnHeader: strings.dataViewing.tableHeaders.date,
    width: '300px'
  },
  {
    field: 'price',
    columnHeader: strings.dataViewing.tableHeaders.price,
    width: '300px'
  },
  {
    field: 'aggrVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrVol,
    width: '300px'
  }
];

class DefaultOrderView extends Component {
  render() {
    return <BaseOrderView gridColumns={GRID_COLUMNS} {...this.props} />;
  }
}

export default DefaultOrderView;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/DefaultOrderView.jsx